export const getDeviceLabel = (type: string, name: string) => {
  const postfix: any = {
    totp: 'shown in your MFA application:',
    email: `from email we've sent you to ${name}:`,
    sms: `we've sent you by SMS to number ${name}:`
  }
  return postfix[type]
}
